

export default function Features() {
  const features = [
    {
      icon: 'ri-book-open-line',
      title: '遊びを通じた学び',
      description: '楽しく意味のある活動を通じて、探求と発見による創造性と思考力を育みます。',
    },
    {
      icon: 'ri-heart-line',
      title: '経験豊富な保育士',
      description: '情熱と資格を持った保育士が、忍耐と専門知識、真心を込めて一人ひとりの可能性を育てます。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安心・安全な施設',
      description: '最新のセキュリティシステム、チャイルドプルーフされた空間、厳格な安全プロトコルでご家族に安心を提供します。',
    },
    {
      icon: 'ri-restaurant-line',
      title: '栄養バランスの取れた食事',
      description: 'オーガニック食材を使用した健康的でバランスの取れた食事とおやつを毎日新鮮に調理。アレルギーにも対応します。',
    },
    {
      icon: 'ri-parent-line',
      title: '家族との連携',
      description: '定期的な報告、面談、参加の機会を通じて、ご家族とのオープンなコミュニケーションと協力を大切にしています。',
    },
    {
      icon: 'ri-seedling-line',
      title: '屋外での学び',
      description: '美しい屋外遊び場と自然体験活動で、身体の発達と環境への意識を育みます。',
    },
  ];

  return (
    <section id="features" className="py-24 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-700 px-4 py-1.5 rounded-full text-sm font-bold mb-4">
            <i className="ri-map-pin-2-fill"></i>
            きらり保育園箕面園
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            箕面園の特徴
          </h2>
          <div className="w-20 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            お子さまが成長し、学び、輝くための最適な環境を提供する<strong className="text-teal-700">きらり保育園箕面園</strong>の特徴をご紹介します。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-16 h-16 bg-teal-100 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
